import ReactDOM from 'react-dom/client';
import './App.scss';
import { disableReactDevTools } from '@fvilers/disable-react-devtools';
import App from './App.tsx';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import reportWebVitals from './reportWebVitals';
import '@mantine/core/styles.css';
import '@mantine/tiptap/styles.css';
import '@mantine/dates/styles.css';
import { MantineProvider } from '@mantine/core';
import { setupAxiosInterceptor } from './config/axiosInterceptor';
import styles from './index.module.css';

// Initialize axios interceptor for global error handling
setupAxiosInterceptor();

// Preload custom fonts to ensure they're available
if (document.fonts) {
  document.fonts.load('16px Fixedsys').catch(() => console.warn('Fixedsys font failed to load'));
  document.fonts.load('400 16px Alexfont').catch(() => console.warn('Alexfont Regular failed to load'));
  document.fonts.load('700 16px Alexfont').catch(() => console.warn('Alexfont Bold failed to load'));
}

if (import.meta.env.PROD) {
  disableReactDevTools();
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <MantineProvider withGlobalStyles withNormalizeCSS>
    <div className={styles.container}>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </div>
  </MantineProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
